import React, { createContext, useContext, useState, useCallback } from 'react';

const PostingChooserContext = createContext(null);

export function PostingChooserProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hubContext, setHubContext] = useState(null);

  const openChooser = useCallback((ctx = null) => {
    setHubContext(ctx);
    setIsOpen(true);
  }, []);

  const closeChooser = useCallback(() => {
    setIsOpen(false);
    setHubContext(null);
  }, []);

  return (
    <PostingChooserContext.Provider value={{ isOpen, hubContext, openChooser, closeChooser }}>
      {children}
    </PostingChooserContext.Provider>
  );
}

export function usePostingChooser() {
  const ctx = useContext(PostingChooserContext);
  if (!ctx) throw new Error('usePostingChooser must be used within PostingChooserProvider');
  return ctx;
}
